/* eslint-disable */
(function ($, Drupal) {
  'use strict';
  Drupal.behaviors.butterballConversionsTable = {
    fahrenheitTemperatureConverter: function (valNum) {
      valNum = parseFloat(valNum);
      if (isNaN(valNum)) {
        $('#celsius').val('');
      }
      else {
        $('#celsius').val(Math.round((valNum - 32) / 1.8));
      }
    },
    celsiusTemperatureConverter: function (valNum) {
      valNum = parseFloat(valNum);
      if (isNaN(valNum)) {
        $('#fahrenheit').val('');
      }
      else {
        $('#fahrenheit').val(Math.round((valNum*1.8) + 32));
      }
    },

    attach: function (context, settings) {
      $('#fahrenheit').on('input change', function(e) {
        Drupal.behaviors.butterballConversionsTable.fahrenheitTemperatureConverter($(this).val());
      });
      $('#celsius').on('input change', function(e) {
        Drupal.behaviors.butterballConversionsTable.celsiusTemperatureConverter($(this).val());
      })
    }
  };
})(jQuery, Drupal);

